import { Pipe, PipeTransform } from '@angular/core';
import { ReportCohortGgrType } from '../../interfaces/reports';

@Pipe({
  name: 'reportCohortGgrType'
})
export class ReportCohortGgrTypePipe implements PipeTransform {

  transform(value: ReportCohortGgrType): string {
    const type = {
      [ReportCohortGgrType.TOTAL]: 'Total',
      [ReportCohortGgrType.CASINO]: 'Cassino',
      [ReportCohortGgrType.SPORTS]: 'Esporte',
    };

    return type[value];
  }

}
